import { createI18n } from 'vue-i18n'
import { messages } from './locales/locale.js'
import { UILangEnum } from './enums/uiLangEnum.js'
import { getLocalStorage } from '@ipevo-rd/service-web-utils'
import { StorageKeyEnum } from '@shared-common'

/**
 * 取得當前的語言
 * @return {UILangEnum}
 */
export const getCurrentLocale = (): UILangEnum => {
  //取得當前的語言
  const locale = getLocalStorage(StorageKeyEnum.UILang)

  // 回傳當前語言
  return UILangEnum[locale as keyof typeof UILangEnum] || UILangEnum.English
}

/**
 * 改變語言
 * @param l {UILangEnum}
 * @return {void}
 */
export const changeLocale = (l: UILangEnum): void => {
  if (i18nInstance.global) {
    // 設定當前語言到 i18n
    i18nInstance.global.locale.value = l
  }
}

/**
 * 建立 i18n
 * @return 配置好的 i18n 實例
 */
const createI18nInstance = () =>
  createI18n({
    // 禁止使用舊版的 避免跳出警告
    legacy: false,
    locale: getCurrentLocale(),
    // 如果翻譯缺失，退回到英文
    fallbackLocale: UILangEnum.English,
    messages,
    // 全局注入
    globalInjection: true,
  })

// 導出 i18n 實例
export const i18nInstance = createI18nInstance()
